import React from 'react';

const CustomsReportPage = React.lazy(() => import('pages/reports/generate-customs'));
const GenerateCompliancePage = React.lazy(() => import('pages/reports/generate-compliance'));
const MonthlySummaryReportPage = React.lazy(() => import('pages/reports/monthly-summary-report'));
const InventoryReportPage = React.lazy(() => import('pages/reports/supplier-inventory'));
const PPMPage = React.lazy(() => import('pages/reports/ppm'));
const StatementsPage = React.lazy(() => import('pages/reports/statements'));
const AccountingReportsPage = React.lazy(() => import('pages/reports/accounting'));
const AccountingOrdersReportPage = React.lazy(() => import('pages/reports/accounting/orders'));
const AccountingProfitReportPage = React.lazy(() => import('pages/reports/accounting/profit'));
const AccountingGlobalPaymentsReportPage = React.lazy(() => import('pages/reports/accounting/global-payments'));

const policies = [{ resource: 'trends', action: 'view' }];

export const definitions = [
  {
    path: 'generate-customs',
    policies: policies,
    component: <CustomsReportPage />
  },
  {
    path: 'generate-compliance',
    policies: policies,
    component: <GenerateCompliancePage />
  },
  {
    path: 'monthly-summary',
    policies: policies,
    component: <MonthlySummaryReportPage />
  },
  {
    path: 'inventory',
    policies: [{ resource: 'reportInventory', action: 'generateInventory' }],
    component: <InventoryReportPage />
  },
  {
    path: 'ppm',
    policies: policies,
    component: <PPMPage />
  },
  {
    path: 'ppm/:qsDetails',
    policies: policies,
    component: <PPMPage />
  },
  {
    path: 'statements',
    policies: [{ resource: 'reportsStatements', action: 'view' }],
    component: <StatementsPage />
  },
  {
    path: 'accounting/:report?',
    policies: [{ resource: 'accountingReports', action: 'view' }],
    component: <AccountingReportsPage />
  },
  {
    path: 'accounting/global-payments',
    policies: [{ resource: 'accountingReports', action: 'view' }],
    component: <AccountingGlobalPaymentsReportPage />
  }
];
